<template>
  <RecursiveOrgChart :org=org />
</template>

<script>
// import DynamicOrgChart from '../components/DynamicOrgChart';
import RecursiveOrgChart from '../components/RecursiveOrgChart';

export default {
  components: {
    //DynamicOrgChart,
    RecursiveOrgChart
  },
  data: function() {
      return {
      org: {
          name: 'My Company Rules LLC',
          size: 100,
          chart: [
             {
                jobTitle: 'Founder',
                department: 'Excecutive',
                budgetedHours: '40+',
                salary: '55,000',
                person: {
                    firstName: 'Tom',
                    hireDate: new Date('2001-03-14'),
                    lastName: 'McGee',
                    imageUrl: require('../assets/TomMcGee.jpg')
                },
                reportsHorizontal: true,
                reports: [ 
                    {
                        jobTitle: 'CTO',
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '40,000',
                        person: {
                            firstName: 'Megan',
                            lastName: 'Runn',
                            hireDate: new Date('2001-05-12'),
                            imageUrl: require('../assets/MeganRunn.jpg')
                        },
                        reportsHorizontal: true,
                        reports: [{
                        jobTitle: 'Engineering Intern',
                        department: 'Engineering',
                        budgetedHours: '40',
                        salary: '18/hr',
                        person: {
                            firstName: 'David',
                            lastName: 'Harp',
                            hireDate: new Date('2001-07-19'),
                            imageUrl: require('../assets/DavidHarp.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    }, {
                        jobTitle: 'Engineering Intern',
                        department: 'Engineering',
                        budgetedHours: '40',
                        salary: '18/hr',
                        person: {
                            firstName: 'Lisa',
                            lastName: 'Harp',
                            hireDate: new Date('2001-07-19'),
                            imageUrl: require('../assets/LisaHarp.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    }]
                    },
                    {
                        jobTitle: 'CMO',
                        department: 'Marketing',
                        budgetedHours: '40+',
                        salary: '40,000',
                        person: {
                            firstName: 'Rebecca',
                            lastName: 'August',
                            hireDate: new Date('2001-06-15'),
                            imageUrl: require('../assets/RebeccaAugust.jpg')
                        },
                        reportsHorizontal: true,
                        reports: [{
                        jobTitle: 'Social Media Marketing Intern',
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '14/hr',
                        person: {
                            firstName: 'Kyle',
                            lastName: 'Ikoma',
                            hireDate: new Date('2001-11-03'),
                            imageUrl: require('../assets/KyleIkoma.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    }]
                    }

                ]
              },
              {
                jobTitle: 'Founder',
                department: 'Excecutive',
                budgetedHours: '40+',
                salary: '120,000',
                person: {
                    firstName: 'Tom',
                    hireDate: new Date('2001-03-14'),
                    lastName: 'McGee',
                    imageUrl: require('../assets/TomMcGee.jpg')
                },
                reportsHorizontal: true,
                reports: [ 
                    {
                        jobTitle: 'CTO',
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '80,000',
                        person: {
                            firstName: 'Megan',
                            lastName: 'Runn',
                            hireDate: new Date('2001-05-12'),
                            imageUrl: require('../assets/MeganRunn.jpg')
                        },
                        reportsHorizontal: true,
                        reports: [{
                        jobTitle: 'Senior Software Engineer',
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '60,000',
                        person: {
                            firstName: 'Rachel',
                            lastName: 'Nelson',
                            hireDate: new Date('2004-01-09'),
                            imageUrl: require('../assets/RachelNelson.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    },{
                        jobTitle: 'Junior Software Engineer',
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '45,000',
                        person: {
                            firstName: 'Rodney',
                            lastName: 'Applewood',
                            hireDate: new Date('2004-02-25'),
                            imageUrl: require('../assets/RodneyApplewood.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    }]
                    },
                    {
                        jobTitle: 'CMO',
                        department: 'Marketing',
                        budgetedHours: '40+',
                        salary: '80,000',
                        person: {
                            firstName: 'Rebecca',
                            lastName: 'August',
                            hireDate: new Date('2001-06-15'),
                            imageUrl: require('../assets/RebeccaAugust.jpg')
                        },
                        reportsHorizontal: true,
                        reports: [{
                        jobTitle: 'Social Media Marketer',
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '41,000',
                        person: {
                            firstName: 'Kyle',
                            lastName: 'Ikoma',
                            hireDate: new Date('2001-11-03'),
                            imageUrl: require('../assets/KyleIkoma.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    }]
                    }

                ]
              },
              {
                jobTitle: 'Founder',
                department: 'Excecutive',
                budgetedHours: '40+',
                salary: '120,000',
                person: {
                    firstName: 'Tom',
                    hireDate: new Date('2001-03-14'),
                    lastName: 'McGee',
                    imageUrl: require('../assets/TomMcGee.jpg')
                },
                reportsHorizontal: true,
                reports: [ 
                    {
                        jobTitle: 'CTO',
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '180,000',
                        person: {
                            firstName: 'Megan',
                            lastName: 'Runn',
                            hireDate: new Date('2001-05-12'),
                            imageUrl: require('../assets/MeganRunn.jpg')
                        },
                        reportsHorizontal: true,
                        reports: [{
                        jobTitle: 'Merchant App Lead',
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '120,000',
                        person: {
                            firstName: 'Rachel',
                            lastName: 'Nelson',
                            hireDate: new Date('2004-01-09'),
                            imageUrl: require('../assets/RachelNelson.jpg')
                        },
                        reportsHorizontal: false,
                        reports: []
                    },{
                        jobTitle: 'Software Engineer',
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '75,000',
                        person: {
                            firstName: 'Rodney',
                            lastName: 'Applewood',
                            hireDate: new Date('2004-02-25'),
                            imageUrl: require('../assets/RodneyApplewood.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    }]
                    },
                    {
                        jobTitle: 'CMO',
                        department: 'Marketing',
                        budgetedHours: '40+',
                        salary: '130,000',
                        person: null,
                        reportsHorizontal: true,
                        reports: [{
                        jobTitle: 'Social Media Marketer',
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '55,000',
                        person: {
                            firstName: 'Kyle',
                            lastName: 'Ikoma',
                            hireDate: new Date('2001-11-03'),
                            imageUrl: require('../assets/KyleIkoma.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    }]
                    },
                    {
                        jobTitle: 'COO',
                        department: 'Operations',
                        budgetedHours: '40+',
                        salary: '120,000',
                        person: {
                            firstName: 'Lucas',
                            lastName: 'Petrol',
                            hireDate: new Date('2011-11-25'),
                            imageUrl: require('../assets/LucasPetrol.jpg')
                        },
                        reportsHorizontal: true,
                        reports: [{
                        jobTitle: 'HR Generalist',
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '55,000',
                        person: {
                            firstName: 'Clay',
                            lastName: 'Zunfer',
                            hireDate: new Date('2012-04-22'),
                            imageUrl: require('../assets/ClayZunfer.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    },
                    {
                        jobTitle: 'Technical Recruiter',
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '55,000 + commission',
                        person: {
                            firstName: 'Emily',
                            lastName: 'Mandin',
                            hireDate: new Date('2012-04-22'),
                            imageUrl: require('../assets/EmilyMandin.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    }]
                    }

                ]
              },
           {
                jobTitle: 'Founder',
                department: 'Excecutive',
                budgetedHours: '40+',
                salary: '120,000',
                person: {
                    firstName: 'Tom',
                    hireDate: new Date('2001-03-14'),
                    lastName: 'McGee',
                    imageUrl: require('../assets/TomMcGee.jpg')
                },
                reportsHorizontal: true,
                reports: [ 
                    {
                        jobTitle: 'CTO',
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '180,000',
                        person: {
                            firstName: 'Megan',
                            lastName: 'Runn',
                            hireDate: new Date('2001-05-12'),
                            imageUrl: require('../assets/MeganRunn.jpg')
                        },
                        reportsHorizontal: true,
                        reports: [{
                        jobTitle: 'Merchant App Team Lead',
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '120,000',
                        person: {
                            firstName: 'Rachel',
                            lastName: 'Nelson',
                            hireDate: new Date('2004-01-09'),
                            imageUrl: require('../assets/RachelNelson.jpg')
                        },
                        reportsHorizontal: true,
                        reports: [{
                        jobTitle: 'Software Engineer',
                        department: 'Engineering',
                        budgetedHours: '40',
                        salary: '60,000',
                        person: {
                            firstName: 'David',
                            lastName: 'Harp',
                            hireDate: new Date('2016-05-11'),
                            imageUrl: require('../assets/DavidHarp.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    }, {
                        jobTitle: 'Senior Software Engineer',
                        department: 'Engineering',
                        budgetedHours: '40',
                        salary: '100,000',
                        person: {
                            firstName: 'Lisa',
                            lastName: 'Harp',
                            hireDate: new Date('2005-03-13'),
                            imageUrl: require('../assets/LisaHarp.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    }]
                    },{
                        jobTitle: 'Internal Apps Team Lead',
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '120,000',
                        person: {
                            firstName: 'Rodney',
                            lastName: 'Applewood',
                            hireDate: new Date('2004-02-25'),
                            imageUrl: require('../assets/RodneyApplewood.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    }]
                    },
                    {
                        jobTitle: 'CMO',
                        department: 'Marketing',
                        budgetedHours: '40+',
                        salary: '150,000',
                        person: {
                            firstName: 'Molly',
                            lastName: 'Rapture',
                            hireDate: new Date('2018-01-15'),
                            imageUrl: require('../assets/MollyRapture.jpg')
                        },
                        reportsHorizontal: true,
                        reports: [{
                        jobTitle: 'Social Media Marketer',
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '65,000',
                        person: {
                            firstName: 'Kyle',
                            lastName: 'Ikoma',
                            hireDate: new Date('2001-11-03'),
                            imageUrl: require('../assets/KyleIkoma.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    },
                    {
                        jobTitle: 'Senior Marketer',
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '85,000',
                        person: {
                            firstName: 'Rebecca',
                            lastName: 'August',
                            hireDate: new Date('2017-12-05'),
                            imageUrl: require('../assets/RebeccaAugust.jpg')
                        },
                        reportsHorizontal: false,
                        reports: [{
                        jobTitle: 'Marketing Intern',
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '15/hr',
                        person: {
                            firstName: 'Miranda',
                            lastName: 'Losgrove',
                            hireDate: new Date('2019-05-12'),
                            imageUrl: require('../assets/MirandaLosgrove.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    },{
                        jobTitle: 'Marketing Intern',
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '15/hr',
                        person: null,
                        reportsHorizontal: true,
                        reports: []
                    },{
                        jobTitle: 'Marketing Intern',
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '15/hr',
                        person: null,
                        reportsHorizontal: true,
                        reports: []
                    }]
                    }]
                    },
                    {
                        jobTitle: 'COO',
                        department: 'Operations',
                        budgetedHours: '40+',
                        salary: '120,000',
                        person: {
                            firstName: 'Lucas',
                            lastName: 'Petrol',
                            hireDate: new Date('2011-11-25'),
                            imageUrl: require('../assets/LucasPetrol.jpg')
                        },
                        reportsHorizontal: true,
                        reports: [{
                        jobTitle: 'HR Generalist',
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '55,000',
                        person: {
                            firstName: 'Clay',
                            lastName: 'Zunfer',
                            hireDate: new Date('2012-04-22'),
                            imageUrl: require('../assets/ClayZunfer.jpg')
                        },
                        reportsHorizontal: true,
                        reports: []
                    },
                    {
                        jobTitle: 'Lead Technical Recruiter',
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '55,000 + commission',
                        person: {
                            firstName: 'Emily',
                            lastName: 'Mandin',
                            hireDate: new Date('2012-04-22'),
                            imageUrl: require('../assets/EmilyMandin.jpg')
                        },
                        reportsHorizontal: true,
                        reports: [ {
                        jobTitle: 'Junior Technical Recruiter',
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '30,000 + commission',
                        person: null,
                        reportsHorizontal: true,
                        reports: []
                    }, {
                        jobTitle: 'Junior Technical Recruiter',
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '30,000 + commission',
                        person: null,
                        reportsHorizontal: true,
                        reports: []
                    }, {
                        jobTitle: 'Junior Technical Recruiter',
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '30,000 + commission',
                        person: null,
                        reportsHorizontal: true,
                        reports: []
                    }]
                    }]
                    }

                ]
              }
          ]    
      }
      }
  }
};
</script>
